import TextAndLine from './TextAndLine'

export default TextAndLine
